<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap">
                {{ 'generic.reports' | translate | uppercase }}
            </ion-label>

            <ng-container *ngIf="isEnabledReportsByEmail">
                <ion-button size="small" fill="clear" mode="ios" color="secondary" (click)="openJobFollowUp()">
                    <img width="16" height="16" src="./assets/imgs/task.svg" alt="" />
                    &nbsp;
                    {{ 'generic.job.follow-up.openModal' | translate }}
                </ion-button>
            </ng-container>
        </ion-item>

        <ion-card class="reports-card" mode="ios">
            <ion-card-content class="ion-no-padding">
                <ion-grid>
                    <ion-row>
                        <ion-col size-md="4">
                            <ion-list lines="none" class="reports">
                                <ion-item *ngFor="let report of reports" (click)="selectReport(report)">
                                    <ion-label *ngIf="!showDescriptionReport">{{ report.name | translate }}</ion-label>
                                    <div class="information information-item" *ngIf="showDescriptionReport">
                                        <ion-label>{{ report.name | translate }}</ion-label>
                                        <ion-icon (click)="openDescriptionReport(report)"
                                            [title]="reportDescriptions[report?.id]?.name | translate"
                                            class="bp-question"></ion-icon>
                                    </div>
                                </ion-item>
                            </ion-list>
                        </ion-col>
                        <ion-col size-md="8" class="border-right">
                            <p *ngIf="!selectedReport">
                                {{ 'reports.selectReport' | translate }}
                            </p>

                            <div class="col-data" *ngIf="selectedReport">
                                <ion-item class="description-wrapper">
                                    <ion-label lines="none" class="ion-text-center ion-text-wrap" color="primary">
                                        {{ selectedReport.name | translate | uppercase }}
                                    </ion-label>
                                    <div class="information" *ngIf="showDescriptionReport"
                                        (click)="openDescriptionReport(selectedReport)">
                                        <ion-icon class="bp-question"></ion-icon>
                                        <span>{{ 'Generic.ComoFunciona'| translate }}</span>
                                    </div>
                                </ion-item>
                                <div *ngIf="selectedReport?.id !== ReportType.HistoricExecutiveReportWithEvaluator 
                                            && selectedReport?.id !== ReportType.AllUsersReport">
                                    <ion-item>
                                        <ion-label>
                                            {{ 'reports.selectCycle' | translate }}
                                        </ion-label>
                                        <ion-button class="btn-select-cycle" mode="ios" color="primary" fill="outline" (click)="selectCycle()">
                                            <ion-label>
                                                {{ selectedCycle ? selectedCycle?.name : ('generic.selectCycle' | translate) }}
                                            </ion-label>
                                        </ion-button>
                                    </ion-item>
                                </div>

                                <div *ngIf="selectedReport?.id === ReportType.HistoricExecutiveReportWithEvaluator">
                                    <ion-grid *ngIf="usersToGetReport.length < 10">
                                        <ion-item>
                                            <ion-col size="9">
                                                <ion-card-header>
                                                    <ion-searchbar mode="ios" #userSearch class="section-search-custom"
                                                        [placeholder]="'generic.searchByName' | translate"
                                                        (keyup)="updateSearch($event.target.value)"></ion-searchbar>
                                                </ion-card-header>
                                            </ion-col>
                                            <ion-col class="ion-text-end" size="3" *ngIf="users.length === 0">
                                                <ion-button color="primary" (click)="addCGE()">{{ 'report.importCGEs' |
                                                    translate }}
                                                </ion-button>
                                            </ion-col>
                                        </ion-item>
                                    </ion-grid>

                                    <h2> {{ 'generic.selectedUsers' | translate }} </h2>

                                    <ion-list class="users" *ngIf="usersToGetReport.length < limitUsersToGetReport">
                                        <ion-item *ngFor="let user of users"
                                            [disabled]="user.isSelected && user.isSelected === true"
                                            style="cursor: pointer;">
                                            <p class="user" (click)="setUser(user)">
                                                <b>{{ user.name }}</b><br />
                                                <span class="hoverable">
                                                    {{ 'generic.add' | translate | uppercase }}
                                                </span>
                                                <span *ngIf="user.isSelected && user.isSelected === true">
                                                    ({{ 'generic.UserAlreadySelected' | translate | lowercase }})
                                                </span>
                                            </p>
                                        </ion-item>
                                    </ion-list>

                                    <ion-list class="users" *ngIf="users.length === 0">
                                        <ion-item class="user-details" *ngFor="let user of usersToGetReport">
                                            <ion-col class="user-left" size="1">
                                                <img [src]="user.imageUrl" default="">
                                            </ion-col>
                                            <ion-col size="3" class="user-left">
                                                <span>{{ user.name | uppercase }}</span>
                                            </ion-col>
                                            <ion-col size="3" class="user-right">
                                                <b>{{ user.job }}</b>
                                            </ion-col>
                                            <ion-col size="3" class="user-right">
                                                <ion-button color="danger" (click)="removeUser(user)">{{
                                                    'generic.remove' | translate }}
                                                </ion-button>
                                            </ion-col>
                                        </ion-item>
                                    </ion-list>
                                </div>

                                <div *ngIf="selectedCycle && selectedReport?.id === ReportType.GenericProcess"
                                    class="container-generic-processes">
                                    <div class="generic-processes">
                                        <ion-label (click)="genericProcessesSelect.open()">
                                            {{ 'reports.selectGenericProcess' | translate }}
                                        </ion-label>
                                        <ion-select #genericProcessesSelect
                                            [interfaceOptions]="{cssClass: 'select-generic-processes'}"
                                            [(ngModel)]="selectedGenericProcess"
                                            (ionChange)="selectGenericProcess(selectedGenericProcess)">
                                            <ion-select-option *ngFor="let process of genericProcesses"
                                                [value]="process.cycleProcessConfigId">
                                                {{ process.name }} | {{ process.startDate | date:'dd/MM/yyyy' }}
                                                - {{ process.endDate | date:'dd/MM/yyyy' }}
                                            </ion-select-option>
                                        </ion-select>
                                    </div>
                                </div>
                                
                                <div *ngIf="selectedReport?.id === ReportType.FinalFeedback && selectedCycle">
                                    <ion-col size="12" size-md="3" class="ion-align-self-center">
                                        <ion-item>
                                            <ion-label (click)="genericProcessesSelect.open()">
                                                {{ 'reports.selectGenericProcess' | translate }}
                                            </ion-label>
                                            <ion-select #genericProcessesSelect
                                                        [(ngModel)]="selectedCycleProcessConfigId"
                                                        color="primary">
                                                <ion-select-option *ngFor="let process of finalFeedbackProcesses"
                                                                   [value]="process.cycleProcessConfigId">
                                                    {{ process.name }}
                                                </ion-select-option>
                                            </ion-select>
                                        </ion-item>
                                    </ion-col>
                                </div>
                                
                                <ng-container *ngIf="(selectedReport?.id === ReportType.AllUsersReport) 
                                                        ? false 
                                                        : (selectedCycle 
                                                        && (selectedReport?.id !== ReportType.GenericProcess || selectedGenericProcess)) 
                                                            || (selectedReport?.id === ReportType.HistoricExecutiveReportWithEvaluator 
                                                            && users 
                                                            && users.length === 0)">
                                    <!-- <ion-item>
                                      <ion-label>
                                        {{ 'reports.exportType' | translate }}
                                      </ion-label>
                                      <ion-select [(ngModel)]="directSubordinates" >
                                        <ion-select-option 
                                          [value]="false" >
                                          {{ 'reports.allSubordinates' | translate }}
                                        </ion-select-option>
                                        <ion-select-option 
                                          [value]="true" >
                                          {{ 'reports.directSubordinates' | translate }}
                                        </ion-select-option>
                                      </ion-select>
                                    </ion-item> -->

                                    <ion-item *ngIf="selectedReport?.id !== ReportType.ConsolidatedCalibrationReport"
                                        class="container-filters">
                                        <ion-label (click)="openFilters()">
                                            {{ 'filters.title' | translate }}
                                        </ion-label>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27.41" height="30"
                                            viewBox="0 0 27.41 30" (click)="openFilters()" class="filter-icon">
                                            <path id="Filter_Icon" data-name="Filter_Icon"
                                                d="M522.214,225.509l-10.05,13.706h-.1l-1.173,14.447-3.83,1.846-1.488-16.293h-.111L494.8,225.509Z"
                                                transform="translate(-494.803 -225.509)" />
                                        </svg>
                                    </ion-item>
                                    <div *ngIf="selectedReport?.id !== ReportType.ConsolidatedCalibrationReport"
                                        class="filters">
                                        <span class="filter-item" *ngFor="let filter of selectedFilters; let i = index">
                                            {{ filter.name | translate }}
                                            <ion-icon (click)="removeFilter(i)"
                                                class="bp-close filter-remove"></ion-icon>
                                        </span>
                                    </div>

                                    <ng-container *ngIf="showOptionalFields 
                                                && (!filterByGroupedAttributes || groupedAttributes.length > 0)
                                                && selectedReport?.id !== ReportType.ConsolidatedCalibrationReport">

                                        <app-grouped-attributes-list [fields]="fields"
                                            [showOptionalFields]="showOptionalFields"
                                            [groupedAttributes]="groupedAttributes"
                                            [isGroupedAttributesList]="filterByGroupedAttributes"
                                            (checkAttribute)="checkAttributeId($event)"
                                            (unCheckAttribute)="unCheckAttributeId($event)">
                                        </app-grouped-attributes-list>
                                    </ng-container>

                                    <ion-item>
                                        <ion-col size="12" size-md="12">
                                            <ion-button class="export" color="primary" mode="ios"
                                                [fill]="loadingFile? 'outline' : 'solid'" (click)="export()"
                                                [disabled]="loadingFile">
                                                <div *ngIf="loadingFile" style="display: flex; align-items: center;">
                                                    {{ 'generic.export' | translate }}&nbsp;
                                                    <ion-spinner name="crescent" color="primary">
                                                    </ion-spinner>
                                                </div>
                                                <span *ngIf="!loadingFile">{{ 'generic.export' | translate }}</span>
                                            </ion-button>
                                            <ion-progress-bar type="indeterminate" *ngIf="loadingFile">
                                            </ion-progress-bar>
                                        </ion-col>
                                    </ion-item>
                                </ng-container>
                                <ng-container *ngIf="selectedReport?.id === ReportType.AllUsersReport">
                                    <ion-item>
                                        <ion-col size="12" size-md="12">
                                            <ion-button class="export" color="primary" mode="ios"
                                                [disabled]="loadingFile" (click)="exportUsersReport()">
                                                {{ 'generic.export' | translate }}
                                            </ion-button>
                                            <ion-progress-bar type="indeterminate"
                                                *ngIf="loadingFile"></ion-progress-bar>
                                        </ion-col>
                                    </ion-item>
                                </ng-container>
                            </div>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>
    </div>
</ion-content>